import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys.js'
import CacheManager from '../../../cache/CacheManager.js'
import NachReportPageUI from './NachReportPageUI.js'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js'

class NachReportPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      errorList: null,
      nachAccountList: null,
      monthlyRecords: null,
      yearMonth: null,
      selectedRecord: null,
      downloadMode: false,
      updateMode: false,
      selectedAccountId: null,
      nachFieldUpdateKind: null,
      nachFieldUpdateAccountId: null,
      internalRemarksUpdateMode: false,
      internalRemarksAccountId: null,
      emailToLeadInternal: false,
      sendEmailConfirmOpen: false,
      sendCommConfirmOpen: false,
      sendingComm: false,
      populateConfirmOpen: false,
      submitted: false,
      successMsg: null,
      populatingMonthly: false,
      totals: null,
      selectedCommRecord: null,
      debitDateUpdateMode: false,
      debitDateValue: '',
      debitDateValueError: null,
      debitDateSubmitting: false,
      debitDateModalErrorList: null,
      nachDataPopulatedDateISO: null,
      presentationSentDateISO: null,
    }
  }

  getResolvedYearMonth = () => {
    let year = this.props.match.params.year
    let month = this.props.match.params.month
    if (!year || !month) {
      const now = new Date()
      year = now.getFullYear().toString()
      month = (now.getMonth() + 1).toString()
    }
    const paddedMonth = String(month).padStart(2, '0')
    const yearMonthStr = `${year}-${paddedMonth}`
    const MONTH_NAMES = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ]
    const monthNum = parseInt(month, 10)
    const monthName = MONTH_NAMES[monthNum - 1] || ''

    return {
      year: parseInt(year, 10),
      month: monthNum,
      monthName,
      yearMonthStr,
    }
  }

  render() {
    const { yearMonthStr } = this.getResolvedYearMonth()

    return (
      <NachReportPageUI
        context={this.props.context}
        loading={this.state.loading}
        nachAccountList={this.state.monthlyRecords || this.state.nachAccountList}
        monthlyRecords={this.state.monthlyRecords}
        nachDataPopulatedDateISO={this.state.nachDataPopulatedDateISO}
        presentationSentDateISO={this.state.presentationSentDateISO}
        totals={this.state.totals}
        yearMonth={this.state.yearMonth}
        onRefreshClick={this.onRefreshClick}
        onPopulateMonthlyDataClick={this.onPopulateMonthlyDataClick}
        onPopulateMonthlyDataConfirm={this.onPopulateMonthlyDataConfirm}
        onPopulateConfirmModalRequestClose={this.onPopulateConfirmModalRequestClose}
        populateConfirmOpen={this.state.populateConfirmOpen}
        populatingMonthly={this.state.populatingMonthly}
        onTypeChange={this.onTypeChange}
        //
        onDownloadClick={this.onDownloadClick}
        downloadMode={this.state.downloadMode}
        //
        onToggleIncluded={this.onToggleIncluded}
        onDecisionModalOpen={this.onDecisionModalOpen}
        selectedRecord={this.state.selectedRecord}
        //
        onSendClientCommClick={this.onSendClientCommClick}
        selectedCommRecord={this.state.selectedCommRecord}
        sendCommConfirmOpen={this.state.sendCommConfirmOpen}
        sendingComm={this.state.sendingComm}
        onSendClientCommConfirm={this.onSendClientCommConfirm}
        onSendCommConfirmModalRequestClose={this.onSendCommConfirmModalRequestClose}
        //
        emailToLeadInternal={this.state.emailToLeadInternal}
        sendEmailConfirmOpen={this.state.sendEmailConfirmOpen}
        onSendEmailToInternalClick={this.onSendEmailToInternalClick}
        onSendEmailToInternalConfirm={this.onSendEmailToInternalConfirm}
        onSendEmailConfirmModalRequestClose={this.onSendEmailConfirmModalRequestClose}
        submitted={this.state.submitted}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setSendEmailModalErrorList}
        onCancelEmailToInternal={this.onCancelEmailToInternal}
        //
        updateMode={this.state.updateMode}
        onRegisteredAmountUpdateClick={this.onRegisteredAmountUpdateClick}
        onRegisteredAmountCancelClick={() => { this.setState({ updateMode: false }) }}
        selectedAccountId={this.state.selectedAccountId}
        onNachRemarksUpdateClick={this.onNachRemarksUpdateClick}
        onNachDebitAmountUpdateClick={this.onNachDebitAmountUpdateClick}
        onNachIncludedUpdateClick={this.onNachIncludedUpdateClick}
        onDebitDateUpdateClick={this.onDebitDateUpdateClick}
        debitDateUpdateMode={this.state.debitDateUpdateMode}
        onDebitDateUpdateCancelClick={this.onDebitDateUpdateCancelClick}
        onDebitDateUpdateSubmit={this.onDebitDateUpdateSubmit}
        debitDateValue={this.state.debitDateValue}
        onDebitDateValueChange={this.onDebitDateValueChange}
        debitDateValueError={this.state.debitDateValueError}
        debitDateSubmitting={this.state.debitDateSubmitting}
        debitDateModalErrorList={this.state.debitDateModalErrorList}
        setDebitDateModalErrorList={this.setDebitDateModalErrorList}
        nachFieldUpdateKind={this.state.nachFieldUpdateKind}
        nachFieldUpdateAccountId={this.state.nachFieldUpdateAccountId}
        onNachFieldUpdateCancelClick={this.onNachFieldUpdateCancelClick}
        yearMonthStr={yearMonthStr}
        //
        onNachInternalRemarksUpdateClick={this.onNachInternalRemarksUpdateClick}
        internalRemarksUpdateMode={this.state.internalRemarksUpdateMode}
        internalRemarksAccountId={this.state.internalRemarksAccountId}
        onInternalRemarksUpdateCancelClick={this.onInternalRemarksUpdateCancelClick}
      />
    )
  }

  componentDidMount() {
    this.getNachMonthly(this.props.context)
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.match.params.year === prevProps.match.params.year &&
      this.props.match.params.month === prevProps.match.params.month
    ) {
      return
    }
    this.setState({
      loading: true,
      errorList: null,
      monthlyRecords: null,
      nachAccountList: null,
      nachDataPopulatedDateISO: null,
      presentationSentDateISO: null,
    }, () => {
      this.getNachMonthly(this.props.context)
    })
  }

  getNachMonthly(context) {
    const { yearMonthStr, year, month, monthName } = this.getResolvedYearMonth()

    this.setState({
      loading: true,
      yearMonth: {
        year,
        month,
        monthName,
        yearMonthStr,
      },
    })

    let cacheManager = new CacheManager({
      resource: `/api/su/nach/monthly`,
      cacheKey: CacheKeys.NachMonthly(yearMonthStr),
      callback: this.getNachMonthlyCallback,
      ttlInSecs: 300,
    })
    cacheManager.getObject2(context, {}, { yearMonth: yearMonthStr })
  }

  getNachMonthlyCallback = (response) => {
    let errorList = []
    if (response && response.errorList) {
      response.errorList.forEach((error) => {
        let msg = error ? (typeof error === 'object' ? error.message || String(error) : String(error)) : null
        if (msg) {
          if (typeof msg === 'string' && (msg.includes('status: 500') || msg.includes('Network error: HTTP error! status: 500'))) {
            msg = 'Internal Server Error'
          }
          errorList.push(msg)
        }
      })
    }
    if (response && response.message && (!response.errorList || response.errorList.length === 0)) {
      let msg = response.message
      if (typeof msg === 'string' && (msg.includes('status: 500') || msg.includes('Network error: HTTP error! status: 500'))) {
        msg = 'Internal Server Error'
      }
      errorList.push(msg)
    }

    if (!response) {
      errorList.push('Failed to load NACH monthly report data. Please try again.')
    }

    const hasErrors = errorList.length > 0
    const rawRecords = (!hasErrors && response && response.records) ? response.records : null
    const totals = (!hasErrors && response && response.totalAccounts != null) ? {
      totalAccounts: response.totalAccounts,
      totalIncluded: response.totalIncluded,
      totalAmountDue: response.totalAmountDue,
      totalDebitAmount: response.totalDebitAmount,
      totalClientYes: response.totalClientYes,
      totalClientNo: response.totalClientNo,
      totalClientPending: response.totalClientPending,
    } : null

    this.setState({
      loading: false,
      errorList: hasErrors ? errorList : null,
      monthlyRecords: rawRecords,
      nachAccountList: rawRecords,
      totals: totals,
      nachDataPopulatedDateISO: (!hasErrors && response) ? (response.nachDataPopulatedDateISO || response.nachDataPopulatedDateIso || null) : null,
      presentationSentDateISO: (!hasErrors && response) ? (response.presentationSentDateISO || response.presentationSentDateIso || null) : null,
    })
  }

  onRefreshClick = (preserveSuccessMsg = false) => {
    const { yearMonthStr } = this.getResolvedYearMonth()
    CacheManager.removeObject(CacheKeys.NachMonthly(yearMonthStr))
    this.setState({
      loading: true,
      monthlyRecords: null,
      nachAccountList: null,
      totals: null,
      nachDataPopulatedDateISO: null,
      presentationSentDateISO: null,
      errorList: null,
      successMsg: preserveSuccessMsg ? this.state.successMsg : null,
    })
    this.getNachMonthly(this.props.context)
  }

  onPopulateMonthlyDataClick = () => {
    this.setState({
      populateConfirmOpen: true,
      errorList: null,
      successMsg: null,
    })
  }

  onPopulateConfirmModalRequestClose = () => {
    if (this.state.populatingMonthly) {
      return
    }
    this.setState({
      populateConfirmOpen: false,
      errorList: null,
    })
  }

  onPopulateMonthlyDataConfirm = (event) => {
    if (event && event.preventDefault) {
      event.preventDefault()
    }
    const { yearMonthStr } = this.getResolvedYearMonth()
    this.setState({
      populatingMonthly: true,
      errorList: null,
    })

    const payload = { yearMonth: yearMonthStr }
    const endpoint = `/api/su/nach/monthly/populate?yearMonth=${encodeURIComponent(yearMonthStr)}`

    RestApiUtils.post(
      this.props.context,
      endpoint,
      this.onPopulateMonthlyDataCallback,
      payload
    )
  }

  onPopulateMonthlyDataCallback = (response) => {
    let errorList = []
    if (response && response.errorList && response.errorList.length > 0) {
      response.errorList.forEach((error) => {
        let msg = error ? (typeof error === 'object' ? error.message || String(error) : String(error)) : null
        if (msg) {
          if (typeof msg === 'string' && (msg.includes('status: 500') || msg.includes('Network error: HTTP error! status: 500'))) {
            msg = 'Internal Server Error'
          }
          errorList.push(msg)
        }
      })
    } else if (response && response.message && (!response.errorList || response.errorList.length === 0) && response.success === false) {
      let msg = response.message
      if (typeof msg === 'string' && (msg.includes('status: 500') || msg.includes('Network error: HTTP error! status: 500'))) {
        msg = 'Internal Server Error'
      }
      errorList.push(msg)
    } else if (!response) {
      errorList.push('Failed to refresh monthly NACH presentation data. Please try again.')
    }

    const hasErrors = errorList.length > 0

    if (!hasErrors) {
      const { yearMonthStr } = this.getResolvedYearMonth()
      CacheManager.removeObject(CacheKeys.NachMonthly(yearMonthStr))
      this.setState({
        populatingMonthly: false,
        populateConfirmOpen: false,
        errorList: null,
        successMsg: (response && response.successMsg) || (response && response.message) || 'Monthly NACH presentation data refreshed successfully',
      }, () => {
        this.onRefreshClick(true)
      })
      setTimeout(() => {
        this.setState({ successMsg: null })
      }, 4000)
    } else {
      this.setState({
        populatingMonthly: false,
        populateConfirmOpen: true,
        errorList: errorList,
        successMsg: null,
      })
    }
  }

  onToggleIncluded = (record) => {
    const { yearMonthStr } = this.getResolvedYearMonth()
    const newIncluded = !record.included

    // Optimistically update records
    const updatedRecords = (this.state.monthlyRecords || []).map((r) => {
      if (String(r.accountId) === String(record.accountId)) {
        return { ...r, included: newIncluded }
      }
      return r
    })
    this.setState({
      monthlyRecords: updatedRecords,
      nachAccountList: updatedRecords,
    })

    let debitAmountStr = '0.00'
    if (record.debitAmount) {
      const cleaned = String(record.debitAmount).replace(/[^0-9.-]/g, '').trim()
      if (cleaned && !isNaN(cleaned)) {
        debitAmountStr = parseFloat(cleaned).toFixed(2)
      }
    }

    RestApiUtils.put(
      this.props.context,
      `/api/su/nach/monthly/decision`,
      (response) => {
        const hasErrors = response && response.errorList && response.errorList.length > 0
        CacheManager.removeObject(CacheKeys.NachMonthly(yearMonthStr))
        if (hasErrors) {
          this.onRefreshClick()
        } else {
          this.getNachMonthly(this.props.context)
        }
      },
      {
        yearMonth: String(yearMonthStr),
        accountId: String(record.accountId),
        included: Boolean(newIncluded),
        debitAmount: String(debitAmountStr),
        remark: String(record.remark || ''),
      }
    )
  }

  onDecisionModalOpen = (record, kind = 'decision') => {
    this.setState({
      nachFieldUpdateKind: kind,
      nachFieldUpdateAccountId: record.accountId,
      selectedRecord: record,
    })
  }

  onNachIncludedUpdateClick = (recordOrEvent) => {
    let accountId = null
    let rec = null
    if (recordOrEvent && recordOrEvent.accountId != null) {
      rec = recordOrEvent
      accountId = String(recordOrEvent.accountId)
    } else if (recordOrEvent && recordOrEvent.currentTarget) {
      accountId = recordOrEvent.currentTarget.getAttribute('data-account-id')
      rec = (this.state.monthlyRecords || []).find((r) => String(r.accountId) === String(accountId))
    }
    this.setState({
      nachFieldUpdateKind: 'included',
      nachFieldUpdateAccountId: accountId,
      selectedRecord: rec,
    })
  }

  onNachRemarksUpdateClick = (recordOrEvent) => {
    let accountId = null
    let rec = null
    if (recordOrEvent && recordOrEvent.accountId != null) {
      rec = recordOrEvent
      accountId = String(recordOrEvent.accountId)
    } else if (recordOrEvent && recordOrEvent.currentTarget) {
      accountId = recordOrEvent.currentTarget.getAttribute('data-account-id')
      rec = (this.state.monthlyRecords || []).find((r) => String(r.accountId) === String(accountId))
    }
    this.setState({
      nachFieldUpdateKind: 'remarks',
      nachFieldUpdateAccountId: accountId,
      selectedRecord: rec,
    })
  }

  onNachDebitAmountUpdateClick = (recordOrEvent) => {
    let accountId = null
    let rec = null
    if (recordOrEvent && recordOrEvent.accountId != null) {
      rec = recordOrEvent
      accountId = String(recordOrEvent.accountId)
    } else if (recordOrEvent && recordOrEvent.currentTarget) {
      accountId = recordOrEvent.currentTarget.getAttribute('data-account-id')
      rec = (this.state.monthlyRecords || []).find((r) => String(r.accountId) === String(accountId))
    }
    this.setState({
      nachFieldUpdateKind: 'debitAmount',
      nachFieldUpdateAccountId: accountId,
      selectedRecord: rec,
    })
  }

  onDebitDateUpdateClick = () => {
    let currentDebitDate = ''
    if (this.state.monthlyRecords && this.state.monthlyRecords.length > 0) {
      const recWithDate = this.state.monthlyRecords.find((r) => r.debitDate)
      if (recWithDate && recWithDate.debitDate) {
        currentDebitDate = String(recWithDate.debitDate).trim()
      }
    }
    this.setState({
      debitDateUpdateMode: true,
      debitDateValue: currentDebitDate,
      debitDateValueError: null,
      debitDateModalErrorList: null,
      debitDateSubmitting: false,
    })
  }

  onDebitDateValueChange = (newDate) => {
    this.setState({
      debitDateValue: newDate,
      debitDateValueError: null,
      debitDateModalErrorList: null,
    })
  }

  onDebitDateUpdateCancelClick = () => {
    if (this.state.debitDateSubmitting) {
      return
    }
    this.setState({
      debitDateUpdateMode: false,
      debitDateValueError: null,
      debitDateModalErrorList: null,
    })
  }

  setDebitDateModalErrorList = (errorList) => {
    this.setState({ debitDateModalErrorList: errorList })
  }

  onDebitDateUpdateSubmit = (event) => {
    if (event && event.preventDefault) {
      event.preventDefault()
    }
    if (this.state.debitDateSubmitting) {
      return
    }

    const { debitDateValue } = this.state
    const trimmed = (debitDateValue || '').trim()
    if (!trimmed) {
      this.setState({ debitDateValueError: 'Please select a debit date' })
      return
    }

    const { yearMonthStr } = this.getResolvedYearMonth()

    this.setState({
      debitDateSubmitting: true,
      debitDateModalErrorList: null,
    })

    const payload = {
      yearMonth: String(yearMonthStr),
      debitDate: String(trimmed),
    }

    const url = `/api/su/nach/monthly/debit-date?yearMonth=${encodeURIComponent(yearMonthStr)}&debitDate=${encodeURIComponent(trimmed)}`

    RestApiUtils.put(
      this.props.context,
      url,
      this.onDebitDateUpdateCallback,
      payload
    )
  }

  onDebitDateUpdateCallback = (response) => {
    let errorList = []
    if (response && response.errorList && response.errorList.length > 0) {
      response.errorList.forEach((error) => {
        let msg = error ? (typeof error === 'object' ? error.message || String(error) : String(error)) : null
        if (msg) {
          if (typeof msg === 'string' && (msg.includes('status: 500') || msg.includes('Network error: HTTP error! status: 500'))) {
            msg = 'Internal Server Error'
          }
          errorList.push(msg)
        }
      })
    } else if (response && response.message && (!response.errorList || response.errorList.length === 0) && response.success === false) {
      let msg = response.message
      if (typeof msg === 'string' && (msg.includes('status: 500') || msg.includes('Network error: HTTP error! status: 500'))) {
        msg = 'Internal Server Error'
      }
      errorList.push(msg)
    } else if (!response) {
      errorList.push('Failed to update debit date. Please try again.')
    }

    const hasErrors = errorList.length > 0

    if (!hasErrors) {
      const { yearMonthStr } = this.getResolvedYearMonth()
      CacheManager.removeObject(CacheKeys.NachMonthly(yearMonthStr))

      const hasRecords = response && Array.isArray(response.records)
      const totals = (!hasErrors && response && response.totalAccounts != null) ? {
        totalAccounts: response.totalAccounts,
        totalIncluded: response.totalIncluded,
        totalAmountDue: response.totalAmountDue,
        totalDebitAmount: response.totalDebitAmount,
        totalClientYes: response.totalClientYes,
        totalClientNo: response.totalClientNo,
        totalClientPending: response.totalClientPending,
      } : this.state.totals

      this.setState({
        debitDateSubmitting: false,
        debitDateUpdateMode: false,
        debitDateModalErrorList: null,
        successMsg: (response && response.successMsg) || (response && response.message) || 'Debit date updated successfully',
        ...(hasRecords ? {
          monthlyRecords: response.records,
          nachAccountList: response.records,
          totals: totals,
          nachDataPopulatedDateISO: response.nachDataPopulatedDateISO || response.nachDataPopulatedDateIso || this.state.nachDataPopulatedDateISO,
          presentationSentDateISO: response.presentationSentDateISO || response.presentationSentDateIso || this.state.presentationSentDateISO,
        } : {}),
      }, () => {
        this.onRefreshClick(true)
      })
      setTimeout(() => {
        this.setState({ successMsg: null })
      }, 4000)
    } else {
      this.setState({
        debitDateSubmitting: false,
        debitDateModalErrorList: errorList,
      })
    }
  }

  onNachFieldUpdateCancelClick = () => {
    this.setState({
      nachFieldUpdateKind: null,
      nachFieldUpdateAccountId: null,
      selectedRecord: null,
    })
  }

  onSendClientCommClick = (record) => {
    this.setState({ selectedCommRecord: record || null, sendCommConfirmOpen: true, successMsg: null, errorList: null })
  }

  onSendClientCommConfirm = (event) => {
    if (event && event.preventDefault) {
      event.preventDefault()
    }
    const { yearMonthStr } = this.getResolvedYearMonth()
    const record = this.state.selectedCommRecord
    const accountParam = record && record.accountId ? `&accountId=${record.accountId}` : ''
    this.setState({ sendingComm: true, errorList: null })

    RestApiUtils.post(
      this.props.context,
      `/api/su/nach/monthly/send-communication?yearMonth=${yearMonthStr}${accountParam}`,
      this.onSendClientCommCallback,
      {}
    )
  }

  onSendClientCommCallback = (response) => {
    const rawErrors = (response && response.errorList) || []
    const ok = rawErrors.length === 0
    const { yearMonthStr } = this.getResolvedYearMonth()

    if (ok) {
      CacheManager.removeObject(CacheKeys.NachMonthly(yearMonthStr))
      this.setState({
        sendingComm: false,
        sendCommConfirmOpen: false,
        selectedCommRecord: null,
        errorList: null,
        successMsg: 'Client communication email sent successfully',
        loading: true,
        monthlyRecords: null,
        nachAccountList: null,
        totals: null,
        nachDataPopulatedDateISO: null,
        presentationSentDateISO: null,
      })
      this.getNachMonthly(this.props.context)
      setTimeout(() => {
        this.setState({ successMsg: null })
      }, 3000)
    } else {
      const errorStrings = rawErrors.map((err) => {
        if (typeof err === 'string') return err
        return (err && err.message) || (err && err.errorCode) || 'Failed to send client communication'
      })
      this.setState({
        sendingComm: false,
        sendCommConfirmOpen: true,
        errorList: errorStrings.length > 0 ? errorStrings : ['Failed to send client communication'],
        successMsg: null,
      })
    }
  }

  onSendCommConfirmModalRequestClose = () => {
    this.setState({ sendingComm: false, sendCommConfirmOpen: false, selectedCommRecord: null, errorList: null })
  }

  onSendEmailToInternalClick = () => {
    this.setState({ sendEmailConfirmOpen: true, successMsg: null, errorList: null })
  }

  onSendEmailToInternalConfirm = (event) => {
    if (event && event.preventDefault) {
      event.preventDefault()
    }
    const context = this.props.context
    const { yearMonthStr } = this.getResolvedYearMonth()
    this.setState({ submitted: true, errorList: null })

    RestApiUtils.post(
      context,
      `/api/su/nach/monthly/emailToInternal/nachTransaction?yearMonth=${encodeURIComponent(yearMonthStr)}`,
      this.onSendEmailToInternalCallback,
      {}
    )
  }

  onSendEmailConfirmModalRequestClose = () => {
    this.setState({ submitted: false, sendEmailConfirmOpen: false, errorList: null })
  }

  setSendEmailModalErrorList = (errorList) => {
    this.setState({ errorList })
  }

  onSendEmailToInternalCallback = (response) => {
    const rawErrors = (response && response.errorList) || []
    const ok = rawErrors.length === 0
    const errorStrings = rawErrors.map((err) => {
      if (typeof err === 'string') return err
      return (err && err.message) || (err && err.errorCode) || 'Failed to send email to Worldline'
    })
    this.setState({
      submitted: false,
      errorList: errorStrings.length > 0 ? errorStrings : (ok ? [] : ['Failed to send email to Worldline']),
      successMsg: ok ? ((response && response.successMsg) || 'NACH transaction email sent to Worldline successfully') : null,
      sendEmailConfirmOpen: !ok,
      emailToLeadInternal: ok ? false : this.state.emailToLeadInternal,
    })
    if (ok) {
      const { yearMonthStr } = this.getResolvedYearMonth()
      CacheManager.removeObject(CacheKeys.NachMonthly(yearMonthStr))
      this.getNachMonthly(this.props.context)
      setTimeout(() => {
        this.setState({ successMsg: null })
      }, 3000)
    }
  }

  onRegisteredAmountUpdateClick = (event) => {
    let selectedAccountId = event.currentTarget.getAttribute('data-account-id')
    this.setState({ updateMode: true, selectedAccountId: selectedAccountId })
  }

  onNachInternalRemarksUpdateClick = (event) => {
    const accountId = event.currentTarget.getAttribute('data-account-id')
    this.setState({ internalRemarksUpdateMode: true, internalRemarksAccountId: accountId })
  }

  onInternalRemarksUpdateCancelClick = () => {
    this.setState({ internalRemarksUpdateMode: false, internalRemarksAccountId: null })
  }

  onCancelEmailToInternal = () => {
    this.setState({ emailToLeadInternal: false, submitted: false, successMsg: null, errorList: null })
  }

  onDownloadClick = () => {
    let context = this.props.context
    const { year, month, yearMonthStr } = this.getResolvedYearMonth()

    this.setState({ downloadMode: true })
    RestApiUtils.get(
      context,
      `/api/su/nach/monthly/report/excel/fileDownloadSignedUrl`,
      this.onDownloadClickCallback,
      null,
      { year: year, month: month, yearMonth: yearMonthStr, stp: context.filter === 'stp' ? true : false }
    )
  }

  onDownloadClickCallback = (response) => {
    this.setState({ downloadMode: false, errorList: response.errorList })
    if (response.errorList && response.errorList.length === 0 && response.signedUrl) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }

  onTypeChange = (type) => {
    // filter changed (e.g. stp)
    this.onRefreshClick()
  }
}

export default withRouter(NachReportPageSF)
